export default "__VITE_ASSET__DNv_cSQN__"